module.exports = __webpack_public_path__ + "img/te-small.10cce1b6.svg";